import { initializeApp } from "@firebase/app";
import { Analytics, getAnalytics } from "@firebase/analytics";
import {
	getMessaging,
	getToken,
	MessagePayload,
	Messaging,
	onMessage,
	deleteToken
} from "@firebase/messaging";
import AppConfig from '@/core/app.config';
import EventEmitter from "@/modules/Event/EventEmitter";
import { EventEmitterName } from "@/modules/Event/interface";
import { $setFcmToken } from "@/api/auth/auth";
import { authEntity } from "@/models/modules/auth/entity";

initializeApp({
	apiKey: "AIzaSyCPMJW22yDzJ7iyuaQ35ACsWJhtKR-HJNw",
	authDomain: "infinbankcorporate.firebaseapp.com",
	databaseURL: "https://infinbankcorporate.firebaseio.com",
	projectId: "infinbankcorporate",
	storageBucket: "infinbankcorporate.appspot.com",
	messagingSenderId: "626172946730",
	appId: "1:626172946730:web:4deef56b2d8aa8dd5e5653",
	measurementId: "G-XFL19M9E97"
});

export let firebaseAnalytics: Analytics | null = null;

export let firebaseMessaging: Messaging | any = null;

export let firebaseToken: string | null = null;

export const getFirebaseToken = async (): Promise<string | null> => firebaseToken || getToken(
	firebaseMessaging,
	{ vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY }
)
	.then(async r => {
		if (r) {
			AppConfig.firebaseMessagingLogging && console.log('FIREBASE Messaging: Successfully getToken()', r);

			return firebaseToken = r;
		} else {
			AppConfig.firebaseMessagingLogging && console.warn('FIREBASE Messaging: Received empty token from getToken()');
		}

		return null;
	})
	.catch(err => {
		AppConfig.firebaseMessagingLogging && console.warn('FIREBASE Messaging: Failed getToken()', err);

		return null;
	});

if (getAnalytics) firebaseAnalytics = getAnalytics();

if (getMessaging && getToken && onMessage) {
	// TODO hide it to show localhost on mobile

	firebaseMessaging = getMessaging();

	try {
		getFirebaseToken();

		const unregisterMessageHandler = onMessage(
			firebaseMessaging,
			(payload: MessagePayload) => {
				payload && payload.data && new Notification(payload.data.title, {
					onClick: () => window.open(process.env.VUE_APP_HOST_URL),
					...payload.data
				} as any);
			}
		);

		EventEmitter.addListener(EventEmitterName.LOGOUT, () => {
			unregisterMessageHandler();

			firebaseToken = null;

			deleteToken(firebaseMessaging)
				.then(deleted => AppConfig.firebaseMessagingLogging
					&& console.log('FIREBASE Messaging: Success delete token deleteToken()', deleted))
				.catch(error => AppConfig.firebaseMessagingLogging
					&& console.warn('FIREBASE Messaging: Failed delete token deleteToken()', error));
		});
	} catch (error: any) {
		AppConfig.firebaseMessagingLogging && console.log(error);
	}
}